import {useTranslations} from 'use-intl';

const Trans = ({ langKey, context = 'ALL' }) => {
  let t = useTranslations( context );

  return t( langKey )
}

export default Trans;